export default __webpack_public_path__ + "static/airdrops-c89244600d9d77daa05fbfeb57630798.png";